import React from "react";
import { Provider } from "react-redux";
import "./App.css";
import IndexRouter from "./router/IndexRouter";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";

function App() {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <IndexRouter />
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
}

export default App;
